module.exports = __webpack_public_path__ + "img/calendar4-event.33ad7241.svg";